"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ForbiddenImage = void 0;
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ForbiddenImage = () => /*#__PURE__*/React.createElement("svg", {
  width: "140",
  height: "140",
  viewBox: "0 0 140 140",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M69.9998 120C97.6132 120 120 97.6574 120 70C120 42.3425 97.5146 20 69.9998 20C42.3865 20 20 42.3425 20 70C20 97.6574 42.3865 120 69.9998 120Z",
  fill: "#E6E5EF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.737 39.1648V98.0025C117.737 99.7288 116.299 101.167 114.572 101.167H25.1649C23.4386 101.239 22 99.8007 22 98.0744V39.1648C22 37.3666 23.4386 36 25.1649 36H114.572C116.37 36 117.737 37.4385 117.737 39.1648Z",
  fill: "white",
  stroke: "#D3D2E0",
  strokeWidth: "2",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.737 39.1648V43.6963H22V39.1648C22 37.3666 23.4386 36 25.1649 36H114.572C116.37 36 117.737 37.4385 117.737 39.1648Z",
  fill: "#F1F1F5",
  stroke: "#D3D2E0",
  strokeWidth: "2",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.2438 41.1789C26.8397 41.1789 27.3227 40.6958 27.3227 40.1C27.3227 39.5041 26.8397 39.021 26.2438 39.021C25.6479 39.021 25.1649 39.5041 25.1649 40.1C25.1649 40.6958 25.6479 41.1789 26.2438 41.1789Z",
  fill: "#66658D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.6244 41.1789C30.2203 41.1789 30.7034 40.6958 30.7034 40.1C30.7034 39.5041 30.2203 39.021 29.6244 39.021C29.0286 39.021 28.5455 39.5041 28.5455 40.1C28.5455 40.6958 29.0286 41.1789 29.6244 41.1789Z",
  fill: "#66658D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.0769 41.1789C33.6728 41.1789 34.1559 40.6958 34.1559 40.1C34.1559 39.5041 33.6728 39.021 33.0769 39.021C32.4811 39.021 31.998 39.5041 31.998 40.1C31.998 40.6958 32.4811 41.1789 33.0769 41.1789Z",
  fill: "#66658D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.1 128.6C120.364 128.6 122.2 126.764 122.2 124.5C122.2 122.236 120.364 120.4 118.1 120.4C115.835 120.4 114 122.236 114 124.5C114 126.764 115.835 128.6 118.1 128.6Z",
  fill: "#9F9FBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.1 112.6C125.646 112.6 126.9 111.346 126.9 109.8C126.9 108.254 125.646 107 124.1 107C122.553 107 121.3 108.254 121.3 109.8C121.3 111.346 122.553 112.6 124.1 112.6Z",
  fill: "#9F9FBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0377 27.2602C26.5841 27.2602 27.8377 26.0066 27.8377 24.4602C27.8377 22.9138 26.5841 21.6602 25.0377 21.6602C23.4913 21.6602 22.2377 22.9138 22.2377 24.4602C22.2377 26.0066 23.4913 27.2602 25.0377 27.2602Z",
  fill: "#9F9FBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.93767 81.26C10.8096 81.26 13.1377 78.9319 13.1377 76.06C13.1377 73.1881 10.8096 70.86 7.93767 70.86C5.06579 70.86 2.73767 73.1881 2.73767 76.06C2.73767 78.9319 5.06579 81.26 7.93767 81.26Z",
  fill: "#9F9FBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.1376 85.66H45.7376C45.2376 85.66 44.8376 85.16 44.8376 84.56C44.8376 83.96 45.2376 83.46 45.7376 83.46H59.1376C59.6376 83.46 60.0376 83.96 60.0376 84.56C60.0376 85.26 59.6376 85.66 59.1376 85.66Z",
  fill: "#D5DDEA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.2244 86.4876H46.5138C46.0474 86.4876 45.5811 86.0203 45.5811 85.366C45.5811 84.8052 45.9542 84.2444 46.5138 84.2444H60.2244C60.6907 84.2444 61.1571 84.7117 61.1571 85.366C61.1571 86.1137 60.6907 86.4876 60.2244 86.4876Z",
  fill: "#E3EAF2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.7221 100.285H59.7106C57.2856 100.285 55.327 98.3226 55.327 95.8925V65.3287C55.327 56.8231 62.2289 50 70.6231 50C79.0173 50 85.9193 56.9166 85.9193 65.3287V95.9859C86.0125 98.3226 84.0539 100.285 81.7221 100.285ZM64.0943 91.593H77.3385V65.3287C77.3385 61.6834 74.3539 58.6925 70.7164 58.6925C67.0789 58.6925 64.0943 61.6834 64.0943 65.3287V91.593Z",
  fill: "#E6E5EF",
  stroke: "#D3D2E0",
  strokeWidth: "2",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.7692 108.604H50.9433C48.2385 108.604 46 106.361 46 103.65V77.1989C46 74.4884 48.2385 72.2451 50.9433 72.2451H90.7692C93.4741 72.2451 95.7125 74.4884 95.7125 77.1989V103.65C95.7125 106.361 93.4741 108.604 90.7692 108.604Z",
  fill: "white",
  stroke: "#D3D2E0",
  strokeWidth: "2",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.7556 91.2576C75.1014 90.3226 76.013 88.7548 76.013 86.9541C76.013 84.0636 73.6991 81.7418 70.8096 81.7418C67.9202 81.7418 65.6063 84.0636 65.6063 86.9541C65.6063 88.7548 66.5179 90.3226 67.8637 91.2576V95.2226C67.8637 96.8649 69.1656 98.1727 70.8096 98.1727C72.4537 98.1727 73.7556 96.8649 73.7556 95.2226V91.2576Z",
  fill: "#F1F1F5",
  stroke: "#D3D2E0",
  strokeWidth: "2"
}));
exports.ForbiddenImage = ForbiddenImage;